var React = require('react');

function FlagMu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M512 172.139H0V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828L512 172.139z","fill":"#ff4b55","key":0}),React.createElement("path",{"fill":"#41479b","d":"M0 172.141h512v83.86H0z","key":1}),React.createElement("path",{"fill":"#ffe15a","d":"M0 256.001h512v83.86H0z","key":2}),React.createElement("path",{"d":"M503.172 423.725H8.828A8.829 8.829 0 010 414.897v-75.034h512v75.034a8.828 8.828 0 01-8.828 8.828z","fill":"#73af00","key":3})]);
}

FlagMu.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagMu;

FlagMu.default = FlagMu;
